<template>
  <div class="flex w-full p-4">
    <div class="m-auto flex">
      <div class="h-8 w-8">
        <svg x="0px" y="0px" viewBox="0 0 508 508" style="enable-background:new 0 0 508 508;">
          <circle style="fill:#FD8469;" cx="254" cy="254" r="254"></circle>
          <path
            style="fill:#FFFFFF;"
            d="M424.1,336.3L270.2,64c-7.1-12.6-25.2-12.6-32.3,0l-154,272.3c-7,12.4,1.9,27.7,16.2,27.7H408 C422.2,364,431.1,348.7,424.1,336.3z"
          ></path>
          <polygon style="fill:#FFD05B;" points="109.2,337.4 254,81.2 398.8,337.4 "></polygon>
          <g>
            <path
              style="fill:#FFFFFF;"
              d="M272.7,197c0,35.1-8.4,89.1-18.7,89.1c-10.4,0-18.7-54-18.7-89.1s8.4-38.1,18.7-38.1 C264.4,158.9,272.7,161.9,272.7,197z"
            ></path>
            <circle style="fill:#FFFFFF;" cx="254" cy="304.4" r="10.6"></circle>
          </g>
        </svg>
      </div>

      <div class="self-center ml-4">
        <div class="font-bold text-md">Oi!</div>
        <div class="text-xs font-bold text-red-600">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LError",
  props: ["message"]
};
</script>
